import FullWidthLayout from "@/layouts/FullWidthLayout";
import { KPageIndex } from "kinnect-general";
import { Pageable } from "kinnect-mixins";

export default {
	name: "ServiceCenterPage",

	metaInfo: { title: "Services" },

	mixins: [ Pageable ],

	data: () => ( {
		items: [
			{
				title: "Service Map",
				icon: "map",
				to: { name: "serviceMap" }
			},

			{
				title: "Statuses",
				icon: "check_box",
				to: { name: "serviceTypes" }
			}
		]
	} ),

	render() {
		return <FullWidthLayout>
			<KPageIndex items={this.items}></KPageIndex>
		</FullWidthLayout>;
	}
};
